import {Nullable} from '../app/TypeHelpers'

export function numberOrNull(value: Nullable<string>): Nullable<number> {
    if (value === '') {
        return null
    }
    if (value === null) {
        return null
    }
    if (Number.isNaN(Number.parseInt(value, 10))) {
        return null
    }
    return Number(value)
}

export function numberOrZero(value: Nullable<string>): number {
    return numberOrNull(value) || 0
}

export function stringOrEmpty(value: Nullable<number>): string {
    return (value === null) ? '' : `${value}`
}

export function createUUID(): string {
    const randomDigit = () => {
        if (crypto && crypto.getRandomValues) {
            const rands = new Uint8Array(1)
            crypto.getRandomValues(rands)
            return (rands[0] % 16).toString(16)
        } else {
            return (Math.random() * 16).toString(16)
        }
    }
    const crypto = window.crypto
    return 'xxxxxxxx-xxxx-4xxx-8xxx-xxxxxxxxxxxx'.replace(/x/g, randomDigit);
}

export function excludeLineBreaks(value: string): string {
    return value.replace(/\r\n|\r|\n/g, '');
}
